module.exports = __webpack_public_path__ + "media/assets/images/landing/паспорт-6cbe251247b9b442e30a98b4616dcca2.png";